<template lang="pug">
  .fill-width
    .row.ma-0.schedule
      .schedule__calendar(
        :class="{ full: !selectedDay.date }"
      )
        lessons-calendar.sdo-card(
          ref="lessonCalendar"
          @open-day="selectedDay = $event"
        )
      v-slide-x-reverse-transition
        .schedule__lessons(
          v-show="selectedDay.date"
        )
          lessons-list(
            :isTeacher="isTeacher"
            :course="selectedCourse"
            :date="selectedDay.date"
            :lessons="selectedDay.lessons"
            @open-calendar="selectedDay = SELECT_DAY_INITIAL"
          )
</template>

<script>
import { mapGetters } from 'vuex';

import LessonsCalendar from '../components/LessonsCalendar.vue';
import LessonsList from '../components/LessonsList.vue';

const SELECT_DAY_INITIAL = {
  date: null,
  lessons: [],
};

export default {
  components: {
    LessonsCalendar,
    LessonsList,
  },
  data: () => ({
    selectedDay: SELECT_DAY_INITIAL,
    selectedCourse: null,

    SELECT_DAY_INITIAL,
  }),
  computed: {
    ...mapGetters({
      isTeacher: 'auth/isTeacher',
      userData: 'auth/userData',
    }),
    courseQuery() {
      if (!this.$route.meta.trained) {
        return { 'search[teacher]': this.userData.id };
      }
      return { 'search[trained]': true };
    },
  },
  watch: {
    selectedCourse() {
      this.selectedDay = SELECT_DAY_INITIAL;
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule {
  position: relative;

  &__calendar {
    padding-right: 400px;
    width: 100%;
    transition: padding-right 0.1s cubic-bezier(0.25, 1, 0.5, 1);

    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  &__calendar.full {
    display: block;
    padding-right: 0;
  }
  &__lessons {
    position: absolute;
    padding-left: 10px;
    top: 0;
    right: 0;
    width: 400px;

    @media screen and (max-width: 768px) {
      padding-left: 0px;
      width: 100%;
    }
  }
}
</style>
